import React from 'react';
import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Dragger } = Upload;

interface Props {
  csvFile: File | null;
  handleUpload: (file: File) => boolean;
  setCsvFile: (f: File | null) => void;
}

const ImportUploader: React.FC<Props> = ({ csvFile, handleUpload, setCsvFile }) => {
  const { t } = useTranslation();

  return (
    <Dragger
      accept=".csv,.xlsx,.xls"
      beforeUpload={handleUpload}
      multiple={false}
      showUploadList={csvFile ? { showRemoveIcon: true } : false}
      onRemove={() => setCsvFile(null)}
      fileList={csvFile ? [csvFile as any] : []}
      style={{ marginTop: 16 }}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p>{t('import_drag_instruction')}</p>
    </Dragger>
  );
};

export default ImportUploader;
